module.exports = __webpack_public_path__ + "img/lightbox-arrow.cee04bcb.svg";